import Modal from '../Modal/Modal';
import CarMainData from '../../pages/Car/CarMainData';
import { textStyles } from '../../constants/textStyles';
import { colors } from '../../constants/colors';

const CarFixModal = ({ isOpen, car, missingFields, remainingCount, onFixed, onSkip }) => {
  if (!car) return null;

  const carTitle = `ID${car?.id} ${car?.mark || ''} ${car?.model || ''}`.trim();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onSkip}
      shouldCloseOnOverlayClick={false}
      title="Заполните данные автомобиля"
      contentStyle={{ maxHeight: '90vh', overflowY: 'auto' }}
    >
      <div style={{ display: 'grid', gap: 16 }}>
        <div
          style={{
            background: colors.rowYellowBG,
            border: `1px solid ${colors.orange}`,
            borderRadius: 8,
            padding: '12px 16px',
          }}
        >
          <p style={{ ...textStyles.fieldLabel, marginBottom: 6 }}>
            Автомобиль {carTitle} нельзя добавить в сделку — не заполнены обязательные поля:
          </p>
          <p style={{ ...textStyles.fieldLabel, color: colors.red, fontWeight: 700 }}>{missingFields?.join(', ')}</p>
          <p style={{ ...textStyles.inputPlaceholder, marginTop: 6 }}>
            Заполните поля ниже и нажмите «Сохранить изменения» — после этого автомобиль будет добавлен в сделку.
          </p>
        </div>

        {remainingCount > 1 && (
          <p style={{ ...textStyles.inputPlaceholder }}>Осталось проверить автомобилей: {remainingCount}</p>
        )}

        <CarMainData containerId={car?.id} onSaved={onFixed} />

        <p
          style={{ ...textStyles.buttonText, textDecoration: 'underline', cursor: 'pointer', textAlign: 'center' }}
          onClick={onSkip}
        >
          Не добавлять этот автомобиль в сделку
        </p>
      </div>
    </Modal>
  );
};

export default CarFixModal;
